import { NumberHelper } from './number.helper';
import {
  IPreInscriptionSummary,
  IPreInscriptionSummaryTotal,
} from '../types/pre-inscription-summary.type';
import { ISummaryStatisticsItem } from '../types/summary.type';
import { ArrayUtils } from '../utils/array.utils';

export class PreInscriptionSummaryHelper {
  /**
   * Calculate total
   *
   * @param inscriptions
   */
  static calculateTotal(inscriptions: IPreInscriptionSummary[]): IPreInscriptionSummaryTotal {
    const totals = inscriptions.map(({ total }) => total);
    const responseDa = totals.map((item) => item.responseDa);
    const afterRapo = totals.map((item) => item.afterRapo);
    const responseRapo = totals.map((item) => item.responseRapo);

    return {
      responseDa: PreInscriptionSummaryHelper.makeTotalStatistics(responseDa),
      afterRapo: PreInscriptionSummaryHelper.makeTotalStatistics(afterRapo),
      responseRapo: PreInscriptionSummaryHelper.makeTotalStatistics(responseRapo),
    };
  }

  /**
   * Make total statistics
   *
   * @param items
   */
  static makeTotalStatistics(items: ISummaryStatisticsItem[]): ISummaryStatisticsItem {
    const fields: (keyof ISummaryStatisticsItem)[] = ['accepted', 'refused', 'total'];

    const result = fields.reduce(
      (obj, field) => ({
        ...obj,
        [field]: ArrayUtils.calculateTotal(items, field),
      }),
      {} as ISummaryStatisticsItem,
    );

    return {
      ...result,
      acceptedFraction: NumberHelper.calculateSimplePercentage(result.accepted, result.total),
      refusedFraction: NumberHelper.calculateSimplePercentage(result.refused, result.total),
    };
  }
}
